//@ts-nocheck
import Button from '../../../components/Button/Button';
import styled, { keyframes } from 'styled-components';
import { useState, useEffect } from 'react';
import { AvatarGroup } from '../../../components/Avatar/Avatar';
import GlobalAiModal from '../../../components/GlobalAiModal/GlobalAiModal';

const avatars = [
  { src: 'https://tackoom.com/avatar2.jpg', alt: 'User 1' },
  { src: 'https://tackoom.com/avatar.jpg', alt: 'User 2' },
  { src: 'https://tackoom.com/avatar3.png', alt: 'User 3' },
  { src: 'https://randomuser.me/api/portraits/women/4.jpg', alt: 'User 4' },
];

const AiSection = () => {
  const [gblAiModalStatus, setGblAiModalStatus] = useState(false);
  const [gblAiModalMsg, setGblAiModalMsg] = useState('');

  const promptClickHandler = (msg) => {
    setGblAiModalMsg(msg);
    setGblAiModalStatus(!gblAiModalStatus);
  };

  return (
    <Container>
      {(() => {
        if (gblAiModalStatus) {
          return (
            <GlobalAiModal
              setGblAiModalStatus={setGblAiModalStatus}
              status={gblAiModalStatus}
              msg={gblAiModalMsg}
            />
          );
        }
      })()}
      <ContainerBox>
        <AiSectionMain id="ai-section">
          <ImgContainer>
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece2.png"
              alt="counseling"
              shape="shape1"
            />
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece1.png"
              alt="counseling"
              shape="shape2"
            />
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece2.png"
              alt="counseling"
              shape="shape3"
            />
          </ImgContainer>
          <Content>
            <Heading className="manrope-semibold ">
              Chat with our AI for solutions!
            </Heading>
            <SubHeading className="manrope-regular">
             Tackoom is  Digital Counseling Marketplace expanding trans-nationally to provide with counseling services through a digital platform, from a large array of advisors.
            </SubHeading>
            <PromptContainer>
              <Prompt
                onClick={() => {
                  promptClickHandler('  I need mental health counseling');
                }}
              >
                I need mental health counseling
              </Prompt>
              <Prompt
                onClick={() => {
                  promptClickHandler('Is Digital Counseling Marketplace Global?');
                }}
              >
                Is Digital Counseling Marketplace Global?
              </Prompt>
              <Prompt
                onClick={() => {
                  promptClickHandler('Suggest me counselors');
                }}
              >
                Suggest me counsling options.
              </Prompt>
              <Prompt
                onClick={() => {
                  promptClickHandler('How to navigate career success?');
                }}
              >
                How to navigate career success?
              </Prompt>
              <Prompt
                onClick={() => {
                  promptClickHandler('Steps for successful scholarships and grants');
                }}
              >
                Steps for successful scholarships and grants
              </Prompt>
            </PromptContainer>

            <OnBoardForm>
              <input
                placeholder="Ask your queries.."
                className="manrope-regular"
                type="text"
                value={gblAiModalMsg}
                onChange={(e) => setGblAiModalMsg(e.target.value)}
              />
              <Button
                onClick={() => {
                  setGblAiModalStatus(true);
                }}
              >
                Ask
              </Button>
            </OnBoardForm>

            <AvatarGroupContainer className="manrope-regular">
              <AvatarGroup limit={'5K'} avatars={avatars} max={3} size={35} />
              <span className="manrope-semibold">Helping 5K+ users</span>
            </AvatarGroupContainer>
          </Content>
          <ImgContainer>
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece2.png"
              alt="counseling"
              shape="shape4"
            />
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece1.png"
              alt="counseling"
              shape="shape3"
            />
            <StyledImg
              className="infinite-updown-animate2"
              src="https://tackoom.com/puzzle_piece2.png"
              alt="counseling"
              shape="shape5"
            />
          </ImgContainer>
        </AiSectionMain>
      </ContainerBox>
    </Container>
  );
};

export default AiSection;

const SubHeading = styled.p`
  color: #aaaaaa;
`;

const OnBoardForm = styled.div`
  display: flex;
  align-items: center;
  height: 2.7rem;
  position: relative;
  min-width: 70%;
  @media (max-width: 768px) {
    min-width: 90%;
  }
  input {
    height: 100%;
    font-size: 1rem;
    outline: none;
    min-width: 100%;
    color: grey;
    background-color: #ffffff;
    border: 1px solid #e3e3e3;
    border-radius: 1.5rem;
    padding-left: 1rem;
  }
  button {
    background-color: #000000;
    position: absolute;
    border-radius: 1.5rem;
    margin: 0;
    height: 80%;
    font-size: 0.9rem;
    right: 0;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 2.25px;
  display: flex;
  flex-wrap: wrap;
`;

const Heading = styled.h2`
  line-height: 1;
  padding: 1rem 0rem;
  font-size: 3rem;
`;

const Paragraph = styled.p`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.9;
  color: #425466;
`;

const AiSectionMain = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 8fr 1fr;
    gap: 2rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  align-items: center;
  padding: 2rem;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledImg = styled.img`
  height: 8rem;
  width: 8rem;
  clip-path: ${({ shape }) =>
    shape === 'shape1'
      ? 'polygon(100% 0, 100% 33%, 36% 34%, 36% 69%, 100% 69%, 100% 100%, 0 100%, 0% 70%, 0% 35%, 0 0)'
      : shape === 'shape2'
      ? 'polygon(55% 0, 55% 27%, 100% 27%, 100% 71%, 55% 71%, 55% 100%, 0 100%, 0% 70%, 0% 35%, 0 0)'
      : shape === 'shape3'
      ? 'polygon(0 0, 100% 0, 100% 27%, 100% 71%, 100% 100%, 55% 100%, 0 100%, 48% 100%, 48% 62%, 0 63%)'
      : shape === 'shape5'
      ? 'polygon(50% 0%, 100% 0, 100% 35%, 100% 100%, 0 100%, 0 69%, 60% 69%, 60% 33%, 0 33%, 0 0)'
      : shape === 'shape4'
      ? 'polygon(50% 0%, 100% 0, 100% 45%, 69% 45%, 69% 100%, 29% 100%, 29% 47%, 0 47%, 0% 35%, 0 0)'
      : 'polygon(50% 0%, 100% 0, 100% 45%, 69% 45%, 69% 100%, 29% 100%, 29% 47%, 0 47%, 0% 35%, 0 0)'};
`;

const Content = styled.div`
  text-align: center;
`;

const PromptContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
  margin: 1rem 0;
`;

const Prompt = styled.button`
  background-color: #f3f3f3;
  border: none;
  padding: 0.7rem 1.2rem;
  border-radius: 1.5rem;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const AvatarGroupContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  span {
    font-size: 0.85rem;
    margin-left: 0.5rem;
  }
`;
